{
  "(optional)": "(дополнительно)",
  "(required)": "(обязательно)"
}
